<template>
  <div v-if="!props.list || !props.list.length" class="text-center">
      <div class="spinner-border text-success " role="status" style="vertical-align: middle;margin-left: 10px;width: 20px;height: 20px;">
          <span class="visually-hidden">Loading...</span>
      </div>
      لطفا شکیبا باشید
  </div>
  <div v-else>
    <select class="form-select my-4" @change="filterShops" v-model="filter">
      <option disabled hidden value="a0">نمایش به ترتیب</option>
      <option value="0">پیش فرض</option>
      <option value="1">بیشترین امتیاز</option>
      <option value="2">بیشترین تنوع</option>
      <option value="3">پرفروش ترین</option>
      <option value="4">ارزان ترین</option>
    </select>
    <main class="p-2 list-container d-flex flex-wrap  w-100 gap-1" v-if="props.list">
      <transition-group name="list">
        <div class="sc-cidCJl fFLFTG shop-item" v-for="item in props.list" :key="item.id">
          <router-link :to="{name:'StoreElement',params:{id:item.id}}">
            <div :title="'فروشگاه '+item.name" class="VendorCard__HtmlLink-mj8102-4 bSkzKe">
              <div class="sc-cCcYRi VendorCard__VendorBox-mj8102-0 gDkoXW gegGdD">
                <div class="sc-dkPtyc VendorCard__ImgWrapper-mj8102-2 dhHFDd bEvpgN">
                  <img :alt="item.name" :src="'https://radap.ir/'+item.store_img1">
                  <div style="position:absolute;left:5px;bottom:5px;opacity:95%;width:50px" class="bg-light text-center px-1 rounded" >
                    <span class="sc-hKwCoD cetlYp bg-close"  v-if="item.close == 1">بسته</span>
                    <span class="sc-hKwCoD cetlYp bg-open" v-else>باز</span>
                  </div>
                </div>
                <div class="sc-dkPtyc djgrpm">
                  <div class="sc-dkPtyc VendorCard__Info-mj8102-1 jZPlKa ">
                    <div class="w-100" style="display: flex;justify-content: space-between">
                      <h2 class="sc-hKwCoD fIHlVh w-100"> {{item.name}} <button class="btn btn-danger  text-light py-0 px-1 ml-1 mb-1" v-for="bitem in item.badge" v-show="item.badge" style="font-size: 10px;font-weight: 700;font-family: 'IranSans';line-height: inherit;">{{ bitem }}</button></h2>
                      <div class="w-50 text-end" v-if="Number(item.poll.count_users)">
                        <small class="pl-1 " style="opacity:70%">({{convertToPersian(String(item.poll.count_users))}}<i class="bi bi-user "></i>)</small>
                        <span class="px-1" style="font-family: IranSans;background-color: #f9f6f2;">{{convertToPersian(String(item.poll.avarage_users))}}<i class="bi bi-star " style="color: rgb(231, 231, 50);padding-right: 0.2em;"></i></span>
                      </div>
                      <div class="w-50 text-end" v-else>
                        <button class="btn btn-danger p-0 px-1" style="font-size: 12px;">جدید</button>
                      </div>
                    </div>
                    <div class="my-1">
                      <button class="btn btn-light ps-0 p-1 text-muted ml-1 mb-1" style="font-size: 12px;">حداقل {{convertToPersian(String(item.min_sale))}} تومان</button>
                      <button class="btn btn-light p-1 text-muted ml-1 mb-1" style="font-size: 12px;" v-for="ditem in item.description">{{ ditem }}</button>
                    </div>
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                          <svg width="1.25rem" height="1.25rem" viewBox="0 0 20 20" fill="#BBB6A5" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.5832 9.58325C14.1229 9.58325 13.7498 9.95635 13.7498 10.4166C13.7498 10.8768 14.1229 11.2499 14.5832 11.2499C15.0434 11.2499 15.4165 10.8768 15.4165 10.4166C15.4165 9.95635 15.0434 9.58325 14.5832 9.58325Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M7.55167 17.6256C5.58545 18.4597 3.42815 17.2569 2.99477 15.2849L2.80188 15.3599C2.54548 15.4596 2.25639 15.4264 2.02933 15.2711C1.80228 15.1157 1.6665 14.8584 1.6665 14.5833L1.6665 9.16659C1.6665 6.62223 2.7184 4.66703 4.31719 3.36431C5.89569 2.07812 7.96582 1.45825 9.99984 1.45825C12.0339 1.45825 14.104 2.07812 15.6825 3.36431C17.2813 4.66703 18.3332 6.62223 18.3332 9.16659V12.4999C18.3332 12.8344 18.1332 13.1364 17.8253 13.2671L7.55167 17.6256ZM9.90247 7.08896L3.45858 7.84706C3.73253 6.47175 4.43547 5.41782 5.36998 4.65636C6.60398 3.65088 8.28385 3.12492 9.99984 3.12492C11.7158 3.12492 13.3957 3.65088 14.6297 4.65636C15.8434 5.64531 16.6665 7.12761 16.6665 9.16659V11.9482L6.90075 16.0913C5.83543 16.5432 4.65792 15.7992 4.58658 14.6659L10.3019 12.4433C10.6222 12.3187 10.8332 12.0103 10.8332 11.6666V7.91659C10.8332 7.67861 10.7314 7.45199 10.5536 7.29386C10.3758 7.13572 10.1388 7.06115 9.90247 7.08896ZM9.1665 11.0965L3.33317 13.365L3.33317 9.53998L9.1665 8.85371L9.1665 11.0965Z"></path>
                          </svg>
                          <div class="sc-dkPtyc gsAfZm px-1">
                            <div class="sc-dkPtyc iDOvlP diqByn">
                              <span v-if="item.delivery_cost == 0" class="sc-hKwCoD jGSjbR diqByn">رایگان!<span class="sc-hKwCoD jvsOGS"></span></span>
                              <span v-else class="sc-hKwCoD jGSjbR ">{{convertToPersian(String(item.delivery_cost))}}<span class="sc-hKwCoD jvsOGS diqByn pr-1">تومان</span></span>
                            </div>
                          </div>
                        </div>
                        <small style="font-size: 0.75rem;font-weight: 700;">رفتن به فروشگاه<i class="bi bi-chevron-left mr-1" style="vertical-align: middle;"></i></small>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </router-link>
        </div>
      </transition-group>
    </main>
    <div v-else style="padding-inline: 2em;padding-top: 1em;padding-bottom: .25em;font-size: 14px;font-weight: 600;">
      در حال حاضر فروشگاه فعالی موجود نیست
    </div>
  </div>
</template>
<script setup> 
import { convertToPersian } from '@/composables/digits'
import { ref,defineProps, watch } from 'vue'
import { useRoute } from 'vue-router';
let route = useRoute();
const props = defineProps(['list'])
watch(() => props.list, () => {
  filter.value = 0;
});
let filter = ref('0')
async function filterShops() {
  let response = await fetch(`https://radap.ir/Backend/api/section/pages/shops/filter.php?catId=${route.params.item}&filter=a${filter.value}`)
  let data = await response.json()
  props.list.sort((a, b) => data.indexOf(a.id) - data.indexOf(b.id));
} 
</script>
<style scoped>
.shop-item{
  transition: 1s;
}
.gAJcda {
  padding: 1.5rem;
}

.kBjvbJ {
  -webkit-box-flex: 1;
  flex-grow: 1;
  box-sizing: border-box;
  width: 100%;
  max-width: 85.375rem;
  margin: 0px auto;
}

.bSoxch {
  box-sizing: border-box;
  width: calc(100% + 2rem);
  margin: calc(-1rem);
  display: flex;
  flex-wrap: wrap;
}

@media (min-width: 0em) {
  .jhAbvW {
    -webkit-box-flex: initial;
    flex-grow: initial;
    flex-basis: 100%;
    max-width: 100%;
    min-width: initial;
  }
}
@media (min-width: 446px) {
  .fFLFTG {
    max-width: 49.5% !important;
  }
}
@media (min-width: 446px) {
  .form-select {
    width: 10em;
    float: left;
    margin-left: 1.5em;
  }
}

.jhAbvW {
  box-sizing: border-box;
}

.bSoxch>* {
  padding: calc(1rem);
}

.iFRMop {
  box-sizing: border-box;
  width: calc(100% + 1.5rem);
  margin: calc(-0.75rem);
  display: flex;
  flex-wrap: wrap;
}

@media (min-width: 0em) {
  .fFLFTG {
    -webkit-box-flex: initial;
    flex-grow: initial;
    flex-basis: 100%;
    max-width: 100%;
    min-width: initial;
  }
}

.fFLFTG {
  box-sizing: border-box;
}

.iFRMop>* {
  padding: calc(0.75rem);
}

.bSkzKe {
  text-decoration: none;
}

.gegGdD {
  -webkit-box-pack: justify;
  justify-content: space-between;
  box-sizing: border-box;
  height: 100%;
  /* margin-bottom: 2rem; */
  padding-bottom: 1.5rem;
  overflow: hidden;
  background-color: rgb(255, 255, 255);
  border: 1px solid rgba(58, 61, 66, 0.06);
  cursor: pointer;
}

.gDkoXW {
  color: rgb(58, 61, 66);
  padding: 0rem;
  box-shadow: rgb(58 61 66 / 6%) 0px 1px 0px, rgb(0 0 0 / 5%) 0px 2px 8px -2px;
  border-radius: 0.5rem;
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.bEvpgN {
  position: relative;
  height: 7em;
  min-height: 7em;
  max-height: 7em;
}

.gegGdD>* {
  flex-shrink: 0;
  text-decoration: none;
  opacity: initial;
}

.gDkoXW>* {
  -webkit-box-flex: 1;
  flex-grow: 1;
}

.dhHFDd {
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  align-content: initial;
  align-items: flex-end;
  flex-flow: row nowrap;
  flex: unset;
}

.bEvpgN>img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

img {
  border-style: none;
}

.hhsuYa {
  position: relative;
  width: 5.5rem;
  height: 5.5rem;
  background-color: rgb(255, 255, 255);
  border-radius: 0.75rem;
  box-shadow: rgb(58 61 66 / 6%) 0px 1px 0px, rgb(0 0 0 / 30%) 0px 8px 32px -16px;
}

.fbkSWj {
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  align-content: initial;
  -webkit-box-align: center;
  align-items: center;
  flex-flow: row nowrap;
  flex: unset;
}

.hhsuYa img {
  border: 1px solid rgba(58, 61, 66, 0.06);
  border-radius: 0.75rem;
}

.cGpdsW {
  position: absolute;
  right: 0px;
  bottom: 25px;
  padding: 0.25rem 0.75rem;
  background-color: rgb(202, 191, 191);
  border-radius: 1rem;
}

.cetlYp {
  /* font-family: IRANSansMobile; */
  font-weight: 700;
  font-size: 12px;
  width: auto;
  height: auto;
  padding: 0px;
  margin: 0px;
  display: inline-block;
  text-align: initial;

}

.gegGdD>* {
  flex-shrink: 0;
  text-decoration: none;
  opacity: initial;
}

.gDkoXW>* {
  -webkit-box-flex: 1;
  flex-grow: 1;
}

.djgrpm {
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  align-content: initial;
  -webkit-box-align: initial;
  align-items: initial;
  flex-flow: column nowrap;
  flex: unset;
}

.kLgBJK {
  margin-top: .75rem;
}

.jZPlKa {
  display: flex;
  -webkit-box-pack: initial;
  place-content: initial;
  -webkit-box-align: center;
  /* align-items: center; */
  padding: .5em;
  flex-flow: column nowrap;
  flex: unset;
}



.fIHlVh {
  font-weight: 700;
  font-size: 16px;
}



.lfuZex> :first-child {
  margin-left: 0.5rem;
}

.lfuZex> :first-child {
  margin-left: 0.5rem;
}

.diqByn {
  /* font-family: IRANSansMobile; */
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1rem;
  width: auto;
  height: auto;
  padding: 0px;
  margin: 0px;
  display: inline-block;
  /* color: rgb(166, 170, 173); */
  color: black;
  text-align: initial;
}

.cxsjNZ>svg {
  margin-left: 0.25rem;
  vertical-align: middle;
}

svg {
  width: 12;
  height: 12;
  fill: rgb(255, 206, 0);
}

.iQvwNW {
  display: flex;
  -webkit-box-pack: center;
  justify-content: start;
  align-content: initial;
  -webkit-box-align: initial;
  align-items: initial;
  flex-flow: row nowrap;
  flex: unset;
}

.llCSyz {
  padding: 0.6875rem 0.875rem;
  text-align: initial;
  background-color: rgb(255, 255, 255);
  border-radius: 4.5rem;
  box-shadow: rgb(58 61 66 / 6%) 0px 1px 0px, rgb(0 0 0 / 5%) 0px 2px 8px -2px;
}


.llCSyz> :first-child>svg {
  vertical-align: middle;
}

.llCSyz> :first-child>* {
  margin-left: 0.5rem;
}

.llCSyz> :first-child>* {
  margin-left: 0.5rem;
}

.haKYkj {
  display: inline-flex;
  -webkit-box-pack: initial;
  place-content: initial;
  -webkit-box-align: initial;
  align-items: initial;
  flex-flow: column nowrap;
  flex: unset;
}

.gsAfZm {
  display: inline-flex;
  -webkit-box-pack: initial;
  place-content: initial;
  -webkit-box-align: center;
  align-items: center;
  flex-flow: row nowrap;
  flex: unset;
}

.iDOvlP {
  display: inline-flex;
  -webkit-box-pack: initial;
  place-content: initial;
  align-items: flex-start;
  flex-flow: column nowrap;
  flex: unset;
}

.jGSjbR {
  /* font-family: IRANSansMobile; */
  font-weight: 700;
  font-size: 0.75rem;
  line-height: 1rem;
  width: auto;
  height: auto;
  padding: 0px;
  margin: 0px;
  display: inline-block;
  color: rgb(58, 61, 66);
  text-align: initial;
}

.jGSjbR {
  /* font-family: IRANSansMobile; */
  font-weight: 700;
  font-size: 0.75rem;
  line-height: 1rem;
  width: auto;
  height: auto;
  padding: 0px;
  margin: 0px;
  display: inline-block;
  color: rgb(58, 61, 66);
  text-align: initial;
}
.bg-open{
  color: green;
}
.bg-close{
  color: red;
}
.w-33{
  width: 33%;
}
.list-enter-active, .list-leave-active, .list-move {
  transition: all 0.5s ease;
}

.list-enter-from, .list-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

.list-leave-active {
  position: absolute;
}
</style>